module.exports = __webpack_public_path__ + "img/generator_snap_2.6577f3b1.jpg";